import {FC} from 'react'

const Error404: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Nie znaleziono strony</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Strona, której szukasz nie istnieje!
      </div>
    </>
  )
}

export {Error404}
